import React, { Component } from "react";

import FormatUtils from "../../utils/formatUtils";

import QuoteViewDetailRow from "./QuoteViewDetailRow";

class CoverageDetails extends Component {
  render() {
    let currentRowColor = "white-coverage-row";
    let toggleSectionStarted = false;
    return (
      <div style={{ overflowY: "auto" }}>
        <table style={{ width: "100%", borderBottom: "solid 1px #d9d8ea" }}>
          <tbody>
            {this.props.quoteVersioningVisible && this.props.quoteWidgetData ? (
              <>
                {this.props.quoteWidgetData.map((widgetData, index, array) => {
                  if (widgetData.WidgetType === "ToggleButton") {
                    toggleSectionStarted = true;
                  }

                  if (
                    (toggleSectionStarted &&
                      widgetData.WidgetType === "ToggleButton") ||
                    !toggleSectionStarted
                  ) {
                    currentRowColor =
                      currentRowColor === "gray-coverage-row"
                        ? "white-coverage-row"
                        : "gray-coverage-row";
                  }

                  const row = (
                    <QuoteViewDetailRow
                      key={widgetData.WidgetId + widgetData.WidgetType}
                      rowColor={currentRowColor}
                      widgetData={widgetData}
                      updateQuoteDetails={this.props.updateQuoteDetails}
                    />
                  );

                  return row;
                })}
              </>
            ) : (
              this.props.coverages.map((coverage) => {
                currentRowColor =
                  currentRowColor === "gray-coverage-row"
                    ? "white-coverage-row"
                    : "gray-coverage-row";

                let coverageRow = this.renderCoverage(
                  coverage,
                  currentRowColor
                );

                return coverageRow;
              })
            )}
          </tbody>
        </table>
      </div>
    );
  }

  renderCoverage(coverage, rowColorClass) {
    return (
      <tr key={coverage.Id + coverage.Description} className={rowColorClass}>
        <td className="lob-details-coverage-description">
          <span>{coverage.Description}</span>
        </td>
        <td>
          <span className="lob-details-coverage-value">
            {this.formatCoverageValue(coverage)}
          </span>
        </td>
      </tr>
    );
  }

  formatCoverageValue(coverage) {
    switch (coverage.ValueType) {
      case "Money":
        return FormatUtils.formatMoney(coverage.Value);
      case "Bit":
        return FormatUtils.formatBool(coverage.Value);
      case "Date":
        return FormatUtils.formatDate(coverage.Value);
      default:
        return coverage.Value;
    }
  }
}

export default CoverageDetails;
